import React, { useEffect, useState } from "react";
import Header from "../components/Delegations/Header";
import { Grid, Typography } from "@mui/material";

const Error_404 = () => {
  return (
    <>
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          zIndex: "9998",
          backgroundColor: "#fff",
        }}
      >
        <Header error_404={true} />
      </div>

      <Grid
        xs={12}
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography style={{ fontSize: "32px" }}>Pagina non trovata</Typography>
      </Grid>
    </>
  );
};

export default Error_404;
